import Spinner from 'react-bootstrap/Spinner';

const BtnSpinner = () => {
    return(
        <>
            <Spinner
                as="span"
                animation="grow"
                size="sm"
                role="status"
                aria-hidden="true"
            />
            Loading...
        </>
    );
}

export default BtnSpinner;